export default __webpack_public_path__ + "static/media/fig_dataVis.bf02bedb.jpg";